export default {
  devType: 'test', // test
  tableLinNum: 6,
  code: '0000',
  sucCode: '0000',
  imgPath: 'http://124.223.88.32/tx/admin',
  // 校验手机验证码
  funPhoneReg (num) {
    // var reg = /^((13[0-9])|(14[5,7,9])|(15[^4])|(18[0-9])|(17[0,1,3,5,6,7,8]))\d{8}$/
    var reg = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[189])\d{8}$/
    // var typeNum = num.match(reg) // (r==null) 不正确
    var typeNum = reg.test(num)
    return typeNum
  }
}



// WEBPACK FOOTER //
// ./src/utils/publicJS.js